export default "__VITE_ASSET__CW2imLoH__"